import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=60346448"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports